import { dataSlice } from "data/utils/buildSlice";
import { dataThunk } from "data/utils/thunks";

const key = "serverInfo";
export const slice = dataSlice({ name: key });
export const { reducer: serverInfo } = slice;
export const getServerInfo = dataThunk(key, slice);
